// extracted by mini-css-extract-plugin
export var productImage = "_zx-0";